export default __webpack_public_path__ + "static/media/icn-small-blocked.91c997d4.svg";